window.htmx = require("htmx.org")

import "./css/variables.css"
import "./css/custom-media.css"
import "./css/reset.css"
import "./css/foundation.css"
import "./css/fonts.css"
import "./css/typography.css"
import "./css/buttons.css"
import "./css/layout.css"
import "./css/cms.css"
import "./css/forms.css"
import "./css/utils.css"
import "./css/navigation.css"
import "./css/footer.css"
import "./css/components.css"
import "./css/competence-centers.css"

import _throttle from "lodash/throttle"
import { render } from "preact"
import { ApplicationForm } from "./js/applicationForm"
import { Gallery } from "./js/gallery"
import { Masonry } from "./js/masonry"
import { initMembershipForm } from "./js/membershipForm"
import { MenuHandler } from "./js/menuHandler"
import { Navigation } from "./js/navigation"
import { initRegions } from "./js/regions"
import { ToggleElements } from "./js/toggleElements"
import { initBacklinks } from "./js/utils/backlink"
import { onReady } from "./js/utils/dom.js"

const $ = window.Bliss
const $$ = $.$

$.ready().then(() => {
  // Menu Handler

  const menuOverlay = $("[data-overlay-wrapper]")

  if (menuOverlay) {
    new MenuHandler(menuOverlay, window.__menu)
  }

  $$("[data-masonry]").forEach(
    (el) => new Masonry(el, el.getAttribute("data-masonry")),
  )

  // Mobile Nav Toggle
  new Navigation()

  new ToggleElements()

  initRegions()

  const scrolledThreshold = 120

  window.addEventListener(
    "scroll",
    _throttle(() => {
      if (window.pageYOffset > scrolledThreshold) {
        document.body.classList.add("scrolled")
        document.body.classList.remove("scrolled--top")
      } else {
        document.body.classList.remove("scrolled")
        document.body.classList.add("scrolled--top")
      }
    }, 100),
  )

  const galleries = $$("[data-gallery]")
  if (galleries) {
    galleries.forEach((e) => {
      new Gallery(e, {
        interval: 5000,
        autoPlay: true,
        createThumbs: true,
        endless: false,
        visibleSlides: 1,
        hasSingleNum: true,
        hasProgressbar: true,
        hasVisibleSlidesNum: false,
      })
    })
  }
  const moodboards = $$("[data-moodboard]")
  if (moodboards) {
    moodboards.forEach((e) => {
      new Gallery(e, {
        interval: 5000,
        autoPlay: true,
        createThumbs: true,
        endless: false,
        visibleSlides: 1,
        hasSingleNum: false,
        hasProgressbar: true,
        hasVisibleSlidesNum: false,
      })
    })
  }

  const factsheets = $$(".factsheets__slider")

  if (factsheets) {
    const mediaQuerySmall = window.matchMedia("(max-width: 750px)")
    const mediaQueryMediumMin = window.matchMedia("(min-width: 750px)")
    const mediaQueryMediumMax = window.matchMedia("(max-width: 1280px)")
    let _visibleSlides = 4

    window.addEventListener("resize", () => {
      if (mediaQueryMediumMin.matches && mediaQueryMediumMax.matches) {
        _visibleSlides = 2
        factsheets.forEach((e) => {
          new Gallery(e, {
            interval: 5000,
            autoPlay: false,
            createThumbs: false,
            endless: false,
            visibleSlides: _visibleSlides,
            hasVisibleSlidesNum: true,
          })
        })
      } else if (mediaQuerySmall.matches && !mediaQueryMediumMin.matches) {
        _visibleSlides = 1
        factsheets.forEach((e) => {
          new Gallery(e, {
            interval: 5000,
            autoPlay: false,
            createThumbs: false,
            endless: false,
            visibleSlides: _visibleSlides,
            hasVisibleSlidesNum: true,
          })
        })
      } else {
        _visibleSlides = 4
        factsheets.forEach((e) => {
          new Gallery(e, {
            interval: 5000,
            autoPlay: false,
            createThumbs: false,
            endless: false,
            visibleSlides: _visibleSlides,
            hasVisibleSlidesNum: true,
          })
        })
      }
    })

    if (mediaQueryMediumMin.matches && mediaQueryMediumMax.matches) {
      _visibleSlides = 2
      factsheets.forEach((e) => {
        new Gallery(e, {
          interval: 5000,
          autoPlay: false,
          createThumbs: false,
          endless: false,
          visibleSlides: _visibleSlides,
          hasVisibleSlidesNum: true,
        })
      })
    } else if (mediaQuerySmall.matches && !mediaQueryMediumMin.matches) {
      _visibleSlides = 1
      factsheets.forEach((e) => {
        new Gallery(e, {
          interval: 5000,
          autoPlay: false,
          createThumbs: false,
          endless: false,
          visibleSlides: _visibleSlides,
          hasVisibleSlidesNum: true,
        })
      })
    } else {
      _visibleSlides = 4
      factsheets.forEach((e) => {
        new Gallery(e, {
          interval: 5000,
          autoPlay: false,
          createThumbs: false,
          endless: false,
          visibleSlides: _visibleSlides,
          hasVisibleSlidesNum: true,
        })
      })
    }
  }

  // article lists
  function articlesMore(el) {
    el.textContent = "..."
    fetch(el.dataset.articlesMore)
      .then((response) => response.text())
      .then((html) => {
        el.parentElement.outerHTML = html
      })
  }
  window.addEventListener("click", (e) => {
    const target = e.target.closest("[data-articles-more]")
    if (target) articlesMore(target)
  })

  // add membership form
  const applicationFormEl = document.querySelector("#application-form")
  const applicationWrapperEl = document.querySelector(
    "#application-form-wrapper",
  )
  const applicationFieldsEl = document.querySelector(
    "#application-form-fields-data",
  )
  if (applicationFormEl && applicationFieldsEl && applicationWrapperEl) {
    const applicationtype = applicationFormEl.getAttribute("data-type")
    render(
      <ApplicationForm
        endpoint={applicationFormEl.dataset.endpoint}
        formEl={applicationFormEl}
        fieldsData={JSON.parse(applicationFieldsEl.textContent)}
        type={applicationtype}
      />,
      applicationWrapperEl,
    )
  }

  initBacklinks()
})

onReady(initMembershipForm, true)
